module.exports = __webpack_public_path__ + "static/media/map-pinn.32319a22.svg";